const enums = { fieldState: ['view', 'edit', 'reset'] };

export default enums;
